import { render, staticRenderFns } from "./formularioDiagnostico.vue?vue&type=template&id=ac93a1ba&scoped=true"
import script from "./formularioDiagnostico.vue?vue&type=script&lang=js"
export * from "./formularioDiagnostico.vue?vue&type=script&lang=js"
import style0 from "./formularioDiagnostico.vue?vue&type=style&index=0&id=ac93a1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac93a1ba",
  null
  
)

export default component.exports